import { useState } from "react";

export const useSelectFilter = <T extends string | number>(
  initialValue: T,
  onChange?: () => void
): {
  value: T;
  handleChange: (value: T) => void;
  setValue: (v: T) => void;
} => {
  const [value, setValue] = useState<T>(initialValue);

  const handleChange = (newValue: T) => {
    setValue(newValue);
    onChange?.();
  };

  return { value, setValue, handleChange };
};
